export default __webpack_public_path__ + "static/media/chooose-white.94de26d8.svg";